enum LoadingType {
  BUBBLES = 'bubbles',
  CIRCLES = 'circles',
  CIRCULAR = 'circular',
  CRESCENT = 'crescent',
  DOTS = 'dots',
  LINES = 'lines',
  LINES_SHARP = 'lines-sharp',
  LINES_SHARP_SMALL = 'lines-sharp-small',
  LINES_SMALL = 'lines-small'
}

enum SESSION_STORAGE_KEYS {
  SESSION_TOKEN = 'sessionToken',
  USER_INFO = 'userInfo',
  USER_GRANTS = 'userGrants',
  USER_ROLE = 'userRole',
  ACTIVE_CONTEXT = 'activeContext',
  SETTLE_JOB_RESPONSE = 'settleJobResponse',
  CURRENT_LANGUAGE = 'currentLanguage',
  TARGET_LANGUAGE = 'targetLanguage',
  REDIRECTION_DATA = 'redirectionData'
}

interface ConfirmationDialogData {
  header: string;
  message: string;
  cancelText: string;
  confirmText: string;
}

interface LoadingMessage {
  endpoint: string;
  method: string;
  message: string;
}

interface PasswordCriteria {
  hasUpperCase: boolean;
  hasLowerCase: boolean;
  hasNumbers: boolean;
  hasSpecialChars: boolean;
  minLength: number;
  passMatch: boolean;
}

interface BackButtonEvent {
  register: (id: number, callback: () => void) => void;
}

enum USER_PROFILE_SEGMENT {
  PERSONAL = 'personal',
  CREDS = 'creds',
  ADDITIONAL = 'additional'
  // ADDRESS = 'address',
  // BANK = 'bank',
  // QUALIFICATIONS = 'qualifications',
  // EXPERIENCE = 'experience',
  // JOB_PREFERENCE = 'job_preference'
}

interface OTP_LOGIN_PAYLOAD {
  phone?: string | null;
  email?: string | null;
  code?: string | null;
}

interface EMAIL_PASSWORD_LOGIN_PAYLOAD {
  email?: string | null;
  password: string | null;
}

interface PHONE_PASSWORD_LOGIN_PAYLOAD {
  phone?: string | null;
  password: string | null;
}

interface SIGNUP_PAYLOAD {
  phone: string;
  email: string;
  password: string;
  confirmPassword?: string;
  is_active: boolean;
  is_superuser: boolean;
  email_verified: boolean;
  phone_verified: boolean;
}

interface USER_DETAILS {
  id: string;
  user_id: string;
  name: string;
  gender: string;
  age: string;
  skills: Skill[];
  languages: Language[];
  credentials: Credential[];
  tags: Tag[];
  user: User;
}

export interface Skill {
  name: string;
}

export interface Language {
  name: string;
}

export interface Credentials {
  id: string;
  descriptor: Descriptor;
  url: string;
  type: string;
}

export interface Descriptor {
  name: string;
  short_desc: string;
  long_desc: string;
  code: string;
}

export interface Tag {
  descriptor: Descriptor;
  list: TagListItem[];
}

export interface TagListItem {
  descriptor: Descriptor;
  value: string;
}

interface User {
  id: string;
  email: string;
  phone: string;
  email_verified: boolean;
  phone_verified: boolean;
}


export interface REDIRECTION_INFO {
  PARAM_URL: string;
  QUERY_PARAMS?: Record<string, string | number | boolean>;
}

export {  LoadingType, LoadingMessage, BackButtonEvent, SESSION_STORAGE_KEYS, PasswordCriteria, ConfirmationDialogData, USER_PROFILE_SEGMENT, OTP_LOGIN_PAYLOAD, EMAIL_PASSWORD_LOGIN_PAYLOAD, PHONE_PASSWORD_LOGIN_PAYLOAD, SIGNUP_PAYLOAD, USER_DETAILS }
